/**
 * useTrackFirstAction — ORB (Onboarding Real)
 *
 * Hook minimalista que registra la primera acción útil del usuario
 * (chat_message | image_generation) llamando a /api/onboarding/track-action.
 *
 * Guard en localStorage (`damyxia_orb_tracked`) para evitar POST repetidos
 * dentro de la misma sesión. El backend es idempotente igual, pero ahorramos
 * el roundtrip.
 *
 * Es best-effort: cualquier error es silencioso (no rompe la UX).
 */
import { useCallback } from 'react';
import axios from 'axios';

import { API_URL } from '../config/api';
import { getToken } from '../utils/authToken';

const LS_KEY = 'damyxia_orb_tracked';

export default function useTrackFirstAction() {
  const trackFirstAction = useCallback(async (actionType) => {
    try {
      if (typeof window !== 'undefined' && localStorage.getItem(LS_KEY) === '1') {
        return;
      }
      const token = getToken();
      if (!token || token === 'guest') return;

      await axios.post(
        `${API_URL}/onboarding/track-action`,
        { action_type: actionType },
        {}
      );

      if (typeof window !== 'undefined') {
        localStorage.setItem(LS_KEY, '1');
      }
    } catch (_) {
      // Silencioso: ORB es best-effort, no debe romper UX.
    }
  }, []);

  return trackFirstAction;
}
